<template>
    <div v-html="value">HTML Box!!</div>
</template>
<script>
export default {
    props: ['value']
};
</script>
